import { isDefined, isStr, resolveNested, splice } from "./utils";

describe("isStr", () => {
    it("returns true for strings", () => {
        expect(isStr("")).toBeTruthy();
        expect(isStr("test")).toBeTruthy();
    });

    it("returns false for non-String values", () => {
        expect(isStr(undefined)).toBeFalsy();
        expect(isStr(1)).toBeFalsy();
        expect(isStr(NaN)).toBeFalsy();
        expect(isStr(() => {})).toBeFalsy();
        expect(isStr(null)).toBeFalsy();
        expect(isStr({})).toBeFalsy();
    });
});

describe("isDefined", () => {
    it("returns false for undefined and null values", () => {
        expect(isDefined(null)).toBeFalsy();
        expect(isDefined(undefined)).toBeFalsy();
        expect(isDefined({})).toBeTruthy();
        expect(isDefined("")).toBeTruthy();
    });
});

describe("resolveNested", () => {
    it("returns value of unnested field", () => {
        expect(resolveNested({ prop: "foo" }, "prop")).toBe("foo");
    });
    it("returns null non existent field", () => {
        expect(resolveNested({ prop: "foo" }, "none")).toBe(null);
        expect(resolveNested({}, "none")).toBe(null);
        expect(resolveNested(null, "none")).toBe(null);
    });

    it("returns value of nested field", () => {
        expect(
            resolveNested(
                { prop: { nested: { prop: "foo" } } },
                "prop.nested.prop"
            )
        ).toBe("foo");
    });
});

describe("splice", () => {
    it("deletes source string before inserting substring", () => {
        expect(splice("foo", 1, 2, "bar")).toBe("fbar");
    });
});
